import { toast } from "@/core/components/ui/toast";
import { getErrorMessage } from "@/core/api/errors";
import {
  useSetCellCommentThreadResolved,
  useWithdrawCellComment,
} from "./query";

// Resolve, reopen and delete, with the failure toast each one needs — shared by
// the grid's comment card and the comments sidebar.
export const useCellCommentActions = (
  businessId: string | null,
  runId: string,
) => {
  const setResolved = useSetCellCommentThreadResolved(businessId, runId);
  const withdraw = useWithdrawCellComment(businessId, runId);

  const run = async (action: Promise<unknown>, failure: string) => {
    try {
      await action;
    } catch (error) {
      toast.error(failure, { description: getErrorMessage(error) });
    }
  };

  return {
    isUpdating: setResolved.isPending || withdraw.isPending,
    resolve: (threadId: string) =>
      run(
        setResolved.mutateAsync({ threadId, resolved: true }),
        "Thread not resolved",
      ),
    reopen: (threadId: string) =>
      run(
        setResolved.mutateAsync({ threadId, resolved: false }),
        "Thread not reopened",
      ),
    deleteComment: (threadId: string, commentId: string) =>
      run(withdraw.mutateAsync({ threadId, commentId }), "Comment not deleted"),
  };
};
